import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { OldDataService } from 'src/app/core/services/old-data.service';
import { environment } from 'src/environments/environment';
import { UtilsService } from '../utils/utils.service';

@Injectable({
	providedIn: 'root',
})
export class RescheduleService {
	constructor(private dataService: OldDataService, private http: HttpClient, private utils: UtilsService) {}


	setRescheduleFree(leadId, alias, userId = null) {
		const url = `${environment.api}reschedules/set_reschedule_free`;
		const payload = { lead_id: leadId, alias: alias, user_id: userId };
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	setRescheduleCharge(leadId, charge, alias, userId = null) {
		const url = `${environment.api}reschedules/set_reschedule_charge`;
		const payload = { lead_id: leadId, charge: charge, alias: alias, user_id: userId };
		const formData = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	denyReschedule(leadId, alias, userId = null) {
		const url = `${environment.api}reschedules/deny_reschedule`;
		const payload = { lead_id: leadId, alias: alias, user_id: userId };
		const formData = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	getPendingReschedules(){
		const url = `${environment.api}reschedules/get_pending`;
		return this.http.get(url);
	}

	getRescheduleRequests(){
		const url = `${environment.api}reschedules/get_requests`;
		return this.http.get(url);
	}

	getCounts(){
		const url = `${environment.api}reschedules/get_reschedule_counts`;
		return this.http.get(url);
	}

	getTodaySolved(){
		const url = `${environment.api}reschedules/get_today_solved_reschedules`;
		return this.http.get(url);
	}
}
